import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 流拍撮合管理列表
Mock.mock(/auctions\/auction_matches\?/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'auction_matches': [{
      'auction_id': 11, // 拍卖活动id，可用于查看出价信息
      'auction_match_id': 1, // 撮合id
      'match_status': 1, // 撮合状态
      'match_status_code': 'created', // 状态代码
      'order_id': 1, // 订单id,用于查看订单详情,可为空
      'match_price': '19999900', // 撮合价，单位：分
      'started_at': '2018-4-20 19:00:00', // 撮合提交的时间
      'auction_car': {
        'car_image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/28iW6XVXNALtGswt9N7GbG.jpg',
        'car_model_name': '丰田 RAV4荣放 2009款 2.0L 手动 经典版',
        'id': 1194
      }
    }],
    'count': 20,
    'page': 1,
    'total_count': 9
  },
  'message': 'ok'
})

// 询价撮合管理列表
Mock.mock(/enquiry_matches\?/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'enquiry_matches': [
      {
        'auction_car': {
          'car_image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/28iW6XVXNALtGswt9N7GbG.jpg',
          'car_model_name': '丰田 RAV4荣放 2009款 2.0L 手动 经典版',
          'id': 1976
        },
        'enquiry_id': 2045,
        'enquiry_match_id': 93,
        'match_price': 1300,
        'match_status': 3,
        'match_status_code': 'completed',
        'order_id': 58,
        'started_at': '2018-05-22 11:21:03'
      }
    ],
    'count': 20,
    'page': 1,
    'total_count': 9
  },
  'message': 'ok'
})

// 车辆详情
Mock.mock(/auctions\/auction_matches\/match_car_details\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction': {
      'id': 11, // 拍卖活动id
      'minimum_price': 19999900, // 起拍价，单位：分
      'contact_name': '陈一陈', // 联系人
      'contact_number': '13800138000' // 联系电话
    },
    'auction_match': {
      'id': 12, //  撮合id
      'match_status': 2, // 撮合状态
      'status_code': 'created', // 状态代码
      'match_price': 111111111, //  撮合价格
      'started_at': '2018-4-19 20:00:01', //  撮合提交时间
      'user_operated_at': '2018-4-19 20:18:59', //  当状态为待付款，此字段表示车商接受撮合的时间；当状态为已拒绝，此字段为车商拒绝撮合的时间；当状态为其他时，此字段为空
      'match_dealer_id': 1, // 撮合车商id
      'match_dealer_name': '陈金牛', // 撮合车商姓名
      'match_dealer_mobile': 13600000000, // 车商电话号码
      'match_dealer_city': '深圳' // 撮合车商城市
    },
    store: {
      address: '高新园',
      latitude: 22.540243,
      longitude: 113.953955,
      name: '中升测试环境店'
    },
    auction_car: {
      id: 3,
      images: [{
        image_url: Mock.Random.dataImage('200x100')
      }, {
        image_url: Mock.Random.dataImage('200x100')
      }],
      car_info: {
        'id|+1': 1,
        transfer_count: 1, // 过户次数
        vin: 'WDBGP57B6PB127810', // 车架号
        car_model_id: 1, // 车型id
        car_model_name: '车型描述', // 车型名称
        mileage: 100000, // 里程
        color_id: 1, // 车身颜色id
        color_name: '黑', // 车身颜色名称
        is_color_changed: true, // 是否变更过车身颜色 (布尔值)
        production_date: '2017-12-12', // 车辆出厂时间
        license_issued_on: '2017-12-12', // 车辆上牌时间
        belonged_province: '所属省份', // 车辆归属地省份
        belonged_province_code: '110000', // 车辆归属地省份code
        belonged_city: '所属城市', // 车辆归属地城市
        belonged_city_code: '110100', // 车辆归属地城市code
        located_province: '所在省份', // 车辆所在地省份
        located_province_code: '120000', // 车辆所在地省份code
        located_city: '所在城市', // 车辆所在地城市
        located_city_code: '120100', // 车辆所在地城市code
        plate_number: '粤A', // 车牌号
        is_refitted: 1, // 车辆是否改装过 1是 0否
        car_character: 1, // 车辆性质id (可以查看文档中的性质列表对照)
        car_character_name: '公户', // 车辆性质名
        usage_character: 1, // 车辆使用性质id (可以查看文档中的车辆使用性质列表对照)
        usage_character_name: '营运', // 车辆使用性质名
        emission_standard: 1, // 排放标准id  (可以查看文档中的排放标准列表对照)
        emission_standard_name: '国五', // 排放标准名称
        note: '备注', // 备注信息
        'info': {
          'config': [
            {
              'group_name': 'basic',
              'name': '基本参数',
              'params': [
                {
                  'name': '车门数(个)',
                  'external_name': 'Body_Doors',
                  'value': null
                },
                {
                  'name': '座位数(个)',
                  'external_name': 'Perf_SeatNum',
                  'value': null
                },
                {
                  'name': '排量(L)',
                  'external_name': 'Engine_ExhaustForFloat',
                  'value': '1.56666666666L'
                },
                {
                  'name': '燃料类型',
                  'external_name': 'Oil_FuelType',
                  'value': null
                },
                {
                  'name': '挡位个数(个)',
                  'external_name': 'UnderPan_ForwardGearNum',
                  'value': null
                },
                {
                  'name': '变速箱类型',
                  'external_name': 'UnderPan_TransmissionType',
                  'value': null
                },
                {
                  'name': '驱动方式',
                  'external_name': 'Perf_DriveType',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'security',
              'name': '主/被动安全设备',
              'params': [
                {
                  'name': '驾驶位安全气囊',
                  'external_name': 'Safe_DriverGasBag',
                  'value': null
                },
                {
                  'name': '副驾驶位安全气囊',
                  'external_name': 'Safe_SubDriverGasBag',
                  'value': null
                },
                {
                  'name': '前排侧安全气囊',
                  'external_name': 'Safe_FsadGasbag',
                  'value': null
                },
                {
                  'name': '后排侧安全气囊',
                  'external_name': 'Safe_BsadGasbag',
                  'value': null
                },
                {
                  'name': '前排头部气囊(气帘)',
                  'external_name': 'Safe_FheadGasbag',
                  'value': null
                },
                {
                  'name': '膝部气囊',
                  'external_name': 'Safe_KneeGasBag',
                  'value': null
                },
                {
                  'name': '安全带气囊',
                  'external_name': 'InStat_BeltBag',
                  'value': null
                },
                {
                  'name': '胎压监测装置',
                  'external_name': 'UnderPan_TyrePressureWatcher',
                  'value': null
                },
                {
                  'name': '刹车防抱死(ABS)',
                  'external_name': 'Safe_ABS',
                  'value': null
                },
                {
                  'name': '盲点检测/并线辅助',
                  'external_name': 'InStat_blindspotdetection',
                  'value': null
                },
                {
                  'name': '夜视系统',
                  'external_name': 'InStat_NightVisionSystem',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'accessory',
              'name': '辅助/操控配置',
              'params': [
                {
                  'name': '泊车雷达(车前)',
                  'external_name': 'UnderPan_PRadar',
                  'value': null
                },
                {
                  'name': '倒车雷达(车后)',
                  'external_name': 'UnderPan_RRadar',
                  'value': null
                },
                {
                  'name': '倒车影像',
                  'external_name': 'UnderPan_RImage',
                  'value': null
                },
                {
                  'name': '全景摄像头',
                  'external_name': 'InStat_PanoramicCamera',
                  'value': null
                },
                {
                  'name': '定速巡航',
                  'external_name': 'InStat_SpeedCruise',
                  'value': null
                },
                {
                  'name': '自适应巡航',
                  'external_name': 'InStat_Automaticcruise',
                  'value': null
                },
                {
                  'name': '自动泊车入位',
                  'external_name': 'InStat_AutoParking',
                  'value': null
                },
                {
                  'name': '上坡辅助',
                  'external_name': 'InStat_UphillAuxiliary',
                  'value': null
                },
                {
                  'name': '自动驻车',
                  'external_name': 'InStat_AutoPark',
                  'value': null
                },
                {
                  'name': '陡坡缓降',
                  'external_name': 'InStat_HDC',
                  'value': null
                },
                {
                  'name': '遥控驾驶',
                  'external_name': 'Safe_Remotedriving',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'external',
              'name': '外部/防盗配置',
              'params': [
                {
                  'name': '天窗型式',
                  'external_name': 'Body_Louver',
                  'value': null
                },
                {
                  'name': '运动外观套件',
                  'external_name': 'OutStat_SportsAppearanceKit',
                  'value': null
                },
                {
                  'name': '铝合金轮圈',
                  'external_name': 'Aluminum_alloy_wheels //  没有标明',
                  'value': null
                },
                {
                  'name': '感应行李厢',
                  'external_name': 'Induction_trunk',
                  'value': null
                },
                {
                  'name': '车顶行李箱架',
                  'external_name': 'OutStat_TopSnelf',
                  'value': null
                },
                {
                  'name': '无钥匙启动系统',
                  'external_name': 'InStat_AIgnitionSys',
                  'value': null
                },
                {
                  'name': '无钥匙进入系统',
                  'external_name': 'nokey_into',
                  'value': null
                },
                {
                  'name': '遥控启动',
                  'external_name': 'InStat_RemoteStart',
                  'value': null
                },
                {
                  'name': '后导流尾翼',
                  'external_name': 'OutStat_InductEmpennage',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'internal',
              'name': '内部配置',
              'params': [
                {
                  'name': '多功能方向盘',
                  'external_name': 'InStat_MultiFuncSteer',
                  'value': null
                },
                {
                  'name': '换挡拨片',
                  'external_name': 'InStat_SteerEtc',
                  'value': null
                },
                {
                  'name': '方向盘加热',
                  'external_name': 'Steering_Wheel_hot',
                  'value': null
                },
                {
                  'name': '方向盘记忆设置',
                  'external_name': 'InStat_SteerMomery',
                  'value': null
                },
                {
                  'name': '方向盘表面材料',
                  'external_name': 'InStat_SteerMaterial',
                  'value': null
                },
                {
                  'name': 'HUD抬头数字显示',
                  'external_name': 'InStat_Hud',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'seat',
              'name': '座椅配置',
              'params': [
                {
                  'name': '座椅材料',
                  'external_name': 'InStat_SeatMaterial',
                  'value': null
                },
                {
                  'name': '运动座椅',
                  'external_name': 'InStat_SportSeat',
                  'value': null
                },
                {
                  'name': '驾驶座腰部支撑调节',
                  'external_name': 'InStat_DSeatProp',
                  'value': null
                },
                {
                  'name': '驾驶座肩部支撑调节',
                  'external_name': 'InStat_AdjustableShoulderSupport',
                  'value': null
                },
                {
                  'name': '驾驶座座椅调节方式',
                  'external_name': 'InStat_DSeatTuneType',
                  'value': null
                },
                {
                  'name': '副驾驶座椅调节方式',
                  'external_name': 'InStat_DASeatTuneType',
                  'value': null
                },
                {
                  'name': '电动座椅记忆',
                  'external_name': 'InStat_ElectricSeatMemory',
                  'value': null
                },
                {
                  'name': '前排座椅加热',
                  'external_name': 'Heated_front_seats',
                  'value': null
                },
                {
                  'name': '后排座椅加热',
                  'external_name': 'Heated_rear_seats',
                  'value': null
                },
                {
                  'name': '前排座椅通风',
                  'external_name': 'The_front_seat_ventilation',
                  'value': null
                },
                {
                  'name': '后排座椅通风',
                  'external_name': 'Rear_seat_ventilation',
                  'value': null
                },
                {
                  'name': '座椅按摩功能',
                  'external_name': 'InStat_SeatKnead',
                  'value': null
                },
                {
                  'name': '第三排座椅',
                  'external_name': 'InStat_3rdRowSeats',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'multimedia',
              'name': '多媒体配置',
              'params': [
                {
                  'name': 'GPS导航系统',
                  'external_name': 'InStat_GPS',
                  'value': null
                },
                {
                  'name': '中控台液晶屏',
                  'external_name': 'InStat_CCEscreen',
                  'value': null
                },
                {
                  'name': '后排液晶屏',
                  'external_name': 'InStat_BEscreen',
                  'value': null
                },
                {
                  'name': '蓝牙系统',
                  'external_name': 'InStat_Bluetooth',
                  'value': null
                },
                {
                  'name': '无线上网功能',
                  'external_name': 'InStat_WireLink',
                  'value': null
                },
                {
                  'name': '车载电视',
                  'external_name': 'InStat_Video',
                  'value': null
                },
                {
                  'name': 'CD',
                  'external_name': 'InStat_CDPlayer',
                  'value': null
                },
                {
                  'name': 'DVD',
                  'external_name': 'InStat_DVDPlayer',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'light',
              'name': '灯光配置',
              'params': [
                {
                  'name': '日间行车灯',
                  'external_name': 'OutStat_DaytimeRunningLights',
                  'value': null
                },
                {
                  'name': '前大灯自动开闭',
                  'external_name': 'OutStat_FLightClose',
                  'value': null
                },
                {
                  'name': '前雾灯',
                  'external_name': 'OutStat_FfogLamp',
                  'value': null
                },
                {
                  'name': '前大灯自动清洗功能',
                  'external_name': 'OutStat_FLightAutoClean',
                  'value': null
                },
                {
                  'name': '前大灯随动转向',
                  'external_name': 'OutStat_FLightSteer',
                  'value': null
                },
                {
                  'name': '前大灯类型',
                  'external_name': 'OutStat_FrontLightType',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'glass',
              'name': '玻璃/后视镜',
              'params': [
                {
                  'name': '前电动车窗',
                  'external_name': 'The_front_power_window',
                  'value': null
                },
                {
                  'name': '后电动车窗',
                  'external_name': 'After_the_electric_window',
                  'value': null
                },
                {
                  'name': '外后视镜电动调节',
                  'external_name': 'OutStat_ReMirrorElecTune',
                  'value': null
                },
                {
                  'name': '外后视镜加热功能',
                  'external_name': 'OutStat_ReMirrorHot',
                  'value': null
                },
                {
                  'name': '内后视镜防眩目功能',
                  'external_name': 'OutStat_ReMirrorDazzle',
                  'value': null
                },
                {
                  'name': '外后视镜电动折叠功能',
                  'external_name': 'OutStat_ReMirrorFold',
                  'value': null
                },
                {
                  'name': '外后视镜记忆功能',
                  'external_name': 'OutStat_ReMirrormemory',
                  'value': null
                },
                {
                  'name': '后窗遮阳帘',
                  'external_name': 'OutStat_BackCurtain',
                  'value': null
                },
                {
                  'name': '后排侧遮阳帘',
                  'external_name': 'OutStat_SecondRowCurtain',
                  'value': null
                },
                {
                  'name': '遮阳板化妆镜',
                  'external_name': 'InStat_FaceMirror',
                  'value': null
                },
                {
                  'name': '后雨刷器',
                  'external_name': 'OutStat_BBrushSensor',
                  'value': null
                }
              ]
            },

            {
              'group_name': 'refrigeration',
              'name': '空调/冰箱',
              'params': [
                {
                  'name': '空调控制方式',
                  'external_name': 'InStat_AirCType',
                  'value': null
                },
                {
                  'name': '后排独立空调',
                  'external_name': 'InStat_BAirCSystem',
                  'value': null
                },
                {
                  'name': '温度分区控制',
                  'external_name': 'InStat_TemperSubCount',
                  'value': null
                },
                {
                  'name': '车载冰箱',
                  'external_name': 'InStat_carFridge',
                  'value': null
                }
              ]
            }
          ],
          'procedure': { // 手续信息
            'purchaseTax': '2', // 购置税
            'drivingLicense': '有', // 行驶证
            'registration': '无', // 登记证
            'annualDue': '2017-03-04', // 年检日期
            'strongInsurance': '2017-03-04', // 交强险到期日
            'commercialInsurance': '2017-03-04', // 商险到期日
            'carInvoice': '有', // 新车发票
            'carWarranty': '过保', // 新车质保
            'key': '112', // 钥匙数量
            'maintenanceManual': '有', // 保养手册
            'instructions': '无', // 说明书
            'unHandleIllegal': '有', // 未处理违章
            'transferTimes': '112', // 过户次数
            'transferTickets': '有', // 过户票
            'newPlace': '2', // 迁往何处
            'proceduresSpend': '2' // 手续补办费用
          }
        }
      }
    }
  }
})

// 获取提交撮合时对应的车商列表
Mock.mock(/auctions\/\d+\/matchable_dealer_users/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_id': 1, // 拍卖id
    'candidates': [
      {
        'dealer_id': 1, // 车商id
        'dealer_name': '陈金牛',
        'mobile': 13200000000,
        'city': '深圳市',
        'max_price': 11111// 最高出价，单位分
      },
      {
        'dealer_id': 2, // 车商id
        'dealer_name': '陈金牛',
        'mobile': 13200000000,
        'city': '深圳市',
        'max_price': 11111// 最高出价，单位分
      }
    ]
  }
})

// 提交撮合
Mock.mock(/auctions\/\d+\/submit_auction_match/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_id': 1, // 拍卖id
    'auction_match_id': 1 // 撮合id
  }
})

// 流拍撮合订单详情
Mock.mock(/auctions\/auction_matches\/match_order\/\d+/, 'get' + mockSwitch, {
  'code': 0, // 0为成功，其他
  'message': 'ok',
  'data': {
    'auction_info': {
      'auction_car_id': 2,
      'auction_id': 1, //  拍卖id
      'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
      'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座', // 车型名称
      'vin': 'LAV323243JFF2211', // 车架号
      'enquiry_id': 1, //  最近的一次有报价的询价，用以查看询价信息
      'purchase_price': 111111 // 收车实价，单位：分
    },
    'match_order': {
      'order_id': 1, // 订单编号
      'match_price': 111111, //  撮合价格，单位：分
      'match_order_status': 1, // 撮合订单状态
      'match_status_code': 'pending_payment',
      'auctual_paid_amount': 11111111, // 实收金额
      'gross_profit_rate': 111111, //  毛利率
      'paid_date': '2018-4-21', //  收款时间
      'paid_note': 'blahblahblahblah' // 收款备注
    },
    'winner_info': {
      'name': '陈金牛',
      'mobile': '13388899921',
      'created_at': '2016-01-21  11:21',
      'organization_type': '二手车经销商',
      'organization_name': '有间二手车行',
      'legal_person_name': '陈建军',
      'province': '广东',
      'city': '深圳',
      'address': '大冲商务中心C座18楼'
    }
  }
})

// 确认收款
Mock.mock(/auctions\/auction_matches\/order_complete\/\d+/, 'post' + mockSwitch, {
  'code': 0, // 0为成功
  'message': 'ok'
})

// 撮合关闭交易
Mock.mock(/auctions\/auction_matches\/order_close\/\d+/, 'put' + mockSwitch, {
  'code': 0, // 0为成功
  'message': 'ok'
})

// 询价场次配置信息
Mock.mock(/auctions\/auction_car_enquiries\/enquiry_config/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'frozen_amount': 800000,
    'commission_amount': 1000
  }
})

// 流拍场次配置信息
Mock.mock(/auctions\/auction_match\/auction_config/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'frozen_amount': 800000,
    'commission_amount': 1000
  }
})
